// firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyA_3tDa3cWCbUWOeOliPC3PcfS1Fh_htkc",
  authDomain: "skilled-bee-459307-b3.firebaseapp.com",
  projectId: "skilled-bee-459307-b3",
  storageBucket: "skilled-bee-459307-b3.firebasestorage.app",
  messagingSenderId: "470050878494",
  appId: "1:470050878494:web:8760c0cb83eabd973d6a0f",
  measurementId: "G-2DPMXDLVKQ"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export { messaging };